var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cross 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M17 8.86957C15.392 8.86957 13.82 9.34641 12.483 10.2398C11.1459 11.1332 10.1038 12.403 9.48846 13.8886C8.87309 15.3743 8.71208 17.009 9.0258 18.5862C9.33951 20.1633 10.1139 21.612 11.2509 22.7491C12.388 23.8862 13.8367 24.6605 15.4138 24.9742C16.991 25.2879 18.6257 25.1269 20.1114 24.5115C21.597 23.8962 22.8668 22.8541 23.7602 21.517C24.6536 20.18 25.1304 18.6081 25.1304 17C25.1279 14.8445 24.2705 12.7779 22.7463 11.2537C21.2221 9.72952 19.1556 8.87211 17 8.86957ZM21.1805 20.1354L20.1354 21.1805L17 18.0451L13.8646 21.1805L12.8195 20.1354L15.9549 17L12.8195 13.8646L13.8646 12.8195L17 15.9549L20.1354 12.8195L21.1805 13.8646L18.0451 17L21.1805 20.1354Z",
    fill: "#231F20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallX);
export default __webpack_public_path__ + "static/media/small-x.b0b1dd90a648a95a16d1e53c3a0b61bb.svg";
export { ForwardRef as ReactComponent };